module.exports = __webpack_public_path__ + "img/vertical_4_2_6000.1ceabea9.png";